import clsx from "clsx";
import { FC, ReactNode } from "react";

import { LoadingSpinner } from "@/features/common/components/animation/LoadingSpinner";

export const TableWrapper: FC<{ header: ReactNode }> = ({
  header,
  children,
}) => {
  return (
    <div className="md:shadow md:border md:border-gray-200 md:rounded-table md:overflow-hidden mb-2">
      {header}
      <div className="divide-y divide-gray-200 md:border-t border-gray-200">
        {children}
      </div>
    </div>
  );
};

export const TableHeader: FC<{ className: string; gap?: string }> = ({
  className,
  children,
  gap = "gap-4",
}) => {
  return (
    <div
      className={clsx(
        "hidden md:grid px-6 py-3 text-base  text-gray-900 bg-gray-50",
        className,
        gap,
      )}
    >
      {children}
    </div>
  );
};

export const TableItemWrapper: FC<{ className: string; gap?: string }> = ({
  className,
  children,
  gap = "gap-4",
}) => {
  return (
    <div className={clsx("grid px-0 md:px-6 py-4", className, gap)}>
      {children}
    </div>
  );
};

export const TableTitle: FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <div className={clsx("mb-6 mt-10", className)}>
      <h1 className="text-xl md:text-2xl  text-gray-900">{children}</h1>
    </div>
  );
};

export const TableFetchMoreLoading = () => {
  return (
    <div className="flex w-full justify-center p-2">
      <LoadingSpinner svgClassName="w-5 h-5" />
    </div>
  );
};
